// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1skd5","title":"Header_title__3ukdH","left":"Header_left__2Z7N0","clinicName":"Header_clinicName__2xff8"};